import { api } from '../index';
import { ITableParams, TAxiosResponse } from '../baseApiTypes';
import {
  IAddGuestImagesModel,
  IAddGuestResponse,
  IAddGuestVideoModel,
  ICreateGuestModel,
  IGuestInfo,
  IGuestInfoResponse,
  ISearchGuestModel,
  TGuestsResponse,
} from './types';
import { RuntimeForm } from '../../../utils/RuntimeForm';

// Guest for Expert and Contact for Journalist.

export const searchGuest = (data: ISearchGuestModel): TAxiosResponse<any> =>
  api.post('/search-guest', data);

export const createGuest = (data: ICreateGuestModel): TAxiosResponse<any> =>
  api.post('/guests/create', new RuntimeForm(data).formData());

export const updateGuest = ({
  id,
  data,
}: {
  id: number;
  data: IGuestInfo;
}): TAxiosResponse<any> =>
  api.post(`/guests/${id}/update`, new RuntimeForm(data).formData());

export const dowloadCVS = (): TAxiosResponse<any> =>
  api.get(`/guests/get-import-template`);

export const getMyGuests = (
  params: ITableParams,
): TAxiosResponse<TGuestsResponse> => api.get('/guests', { params });

export const getGuest = (userId: number): TAxiosResponse<IGuestInfoResponse> =>
  api.get(`/guests/${userId}`);

export const addGuestAvatar = ({
  id,
  formData,
}: any): TAxiosResponse<IAddGuestResponse> =>
  api.post(`/guests/${id}/add-avatar`, formData);

export const addGuestVideo = ({
  id,
  data,
}: IAddGuestVideoModel): TAxiosResponse<any> =>
  api.post(`guests/video/${id}/add`, data);

export const addGuestImages = ({
  id,
  data,
}: IAddGuestImagesModel): TAxiosResponse<any> =>
  api.post(`/guests/image/${id}/add`, data);

export const deleteGuestAvatar = (guestId: number): TAxiosResponse<any> =>
  api.get(`/guests/${guestId}/destroy-avatar`);

export const deleteGuestImage = (imageId: number): TAxiosResponse<any> =>
  api.delete(`/guests/image/${imageId}/destroy`);

export const uploadContacts = (data: any): TAxiosResponse<any> =>
  api.post('/guests/import', data);

export const GuestApi = {
  searchGuest,
  createGuest,
  getMyGuests,
  getGuest,
  addGuestAvatar,
  addGuestVideo,
  addGuestImages,
  updateGuest,
  deleteGuestAvatar,
  deleteGuestImage,
  uploadContacts,
};
